import { useEffect, useState } from "react";
import Header from "../../components/Shared/Header";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, Empty, message, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { getAllClients, getRoles } from "../../Utils/client/client";
import ClientCard from "../../components/Client/ClientCard";
import Loading from "../../components/Shared/Loading";

const { Option } = Select;

const ROLE_NAMES = {
  "superadmin": "Administrateur",
  "client": "Client",
  "exploitation_manager": "Gérant d'exploitation",
  "domain_manager": "Gérant de domaine",
};

const ClientsPage = () => {
  const navigate = useNavigate();
  const [clientListOrigin, setClientListOrigin] = useState([]);
  const [clientListDisplay, setClientListDisplay] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRole, setSelectedRole] = useState(null);
  const [roles, setRoles] = useState([]);

  const navigateTo = (path) => {
    navigate(path);
  };


  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
    } catch (error) {
      console.error(error);
      messageApi.error("Erreur lors du chargement des rôles");
    }
  };

  const mapRoleName = (role_name) => {
    return ROLE_NAMES[role_name];
  };
    

  const fetchAndSetClientList = async () => {
    setLoading(true);
    try {
      const res = await getAllClients();
      setClientListOrigin(res.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      messageApi.error("Erreur lors du chargement des clients");
      setLoading(false);
    }
  };

  const handleDeleteClient = (deletedUserId) => {
    const updatedList = clientListOrigin.filter(
      (client) => client.user.user_id !== deletedUserId
    );
    setClientListOrigin(updatedList);
    messageApi.success("Client supprimé avec succès");
  };

  const searchClient = (e) => {
    const searchValue = e.target.value;
    const filteredClients = clientListOrigin.filter((client) => {
      return (
        client.user?.first_name
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        client.user?.last_name
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        client.user?.company_name
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        client.user?.phone_number
          ?.toLowerCase()
          .includes(searchValue.toLowerCase())
      );
    });
    setClientListDisplay(filteredClients);
  };

  const filterByRole = (value) => {
    setSelectedRole(value);
    if (value) {
      const filteredClients = clientListOrigin.filter(
        (client) => client.user.role_id === value
      );
      setClientListDisplay(filteredClients);
    } else {
      setClientListDisplay(clientListOrigin);
    }
  };

  useEffect(() => {
    fetchAndSetClientList();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (clientListOrigin.length > 0) {
      setClientListDisplay(clientListOrigin);
    }
  }, [clientListOrigin]);

  return (
    <>
      {contextHolder}
      {loading && <Loading />}
      <div className="bg-white min-h-screen">
        <Header title="Liste des clients" />
        <div className="h-[calc(100%-100px)]">
          <div className="relative m-8 h-full flex flex-col items-center">
            {/* Adding Button */}
            <div
              className="fixed flex items-center justify-center rounded-full shadow-lg bg-blue-500 w-16 h-16 bottom-10 right-10 text-white text-2xl cursor-pointer hover:bg-blue-600 transition duration-300 ease-in-out hover:shadow-xl transform hover:-translate-y-1"
              onClick={() => navigateTo("/admin/client/add")}
            >
              <PlusOutlined className="text-3xl" />
            </div>

            {/* Search Input */}
            <div className="w-full max-w-2xl mb-8 flex items-center space-x-4">
              <Input
                size="large"
                className="input-primary border-2 border-gray-200 hover:border-indigo-400 focus:border-indigo-500 flex-1"
                placeholder="Rechercher par nom gérant, nom entreprise, numéro de téléphone"
                prefix={<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
                onChange={searchClient}
              />
              <Select
                value={selectedRole || 'Tous les rôles'}
                onChange={filterByRole}
                className="w-40"
                placeholder="Filtrer par rôle"
              >
                <Option value={'Tous les rôles'}>Tous les rôles</Option>
                {roles.map((role) => (
                  <Option key={role.role_id} value={role.role_id}>
                    {mapRoleName(role.name)}
                  </Option>
                ))}
              </Select>
            </div>

            {/* Clients Cards */}
            {clientListDisplay.length > 0 && roles.length > 0 ? (
              <div className="flex gap-8 flex-wrap justify-center pt-8">
                {clientListDisplay.map((client) => (
                  <ClientCard
                    key={client.user.user_id}
                    clientInfo={client}
                    onDelete={handleDeleteClient}
                    role={roles.find((role) => role.role_id === client.user.role_id).name}
                  />
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center pt-16">
                <Empty
                  description={
                    <span className="text-gray-500 text-lg">
                      Aucun client trouvé
                    </span>
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientsPage;